import { ASYNC_STATUS_ID } from 'constants'
import { API } from 'constants/apiEndPoints'
import { isEmpty } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { useAPI } from 'utils/hooks/useAPI'

export const useReferralData = () => {
  const [state, sendReferralDataQuery, hasStatus] = useAPI(API.REFERRALS_V2_USER, {
    queryType: 'get',
    controlled: true,
    withJwt: true,
  })
  const [referralData, setReferralData] = useState({})

  useEffect(() => {
    sendReferralDataQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasStatus(ASYNC_STATUS_ID.ERROR)) console.log('ACZ ReferralData error', state.error)

    if (hasStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      const data = state.data?.data
      setReferralData(data)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.status.id])

  const isReferralDataLoading = useMemo(() => isEmpty(referralData), [referralData])

  return { referralData, isReferralDataLoading }
}
